import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { decryptData } from '../../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../../utils/Tostify';
import Loader from '../../../components/Loader/Loader';
import { getApplicationActivity } from '../../../api/Applications';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { ITEMS_PER_PAGE } from '../../../utils/constants';

const PatientActivity = ({patientDeatils, activeTab}) => {
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [activity, setActivity] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const getActivity = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getApplicationActivity({dispatch, token, type : "Patient", patientId: patientDeatils?._id, clinicId : localStorage.getItem("currentHospitalId")});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setActivity(responseData);
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(activeTab === "10" && patientDeatils?._id){
        getActivity();
    }
  }, [activeTab, patientDeatils?._id]);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedActivity = activity?.slice(startIndex, endIndex);


  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  return (
    <Fragment>
        {isLoading ? <Loader/> : null}
        <div className="data_patient mt-3">
            <h6 className="form_name list_blk">Activity: </h6>
            <div className="table_space table_listing_color">
            <div className="table-responsive">
                <table>
                <thead>
                <tr className="header_table">
                    <th>Time</th>
                    <th>User</th>
                    <th>Activity</th>
                </tr>
                </thead>
                <tbody>
                {paginatedActivity?.length > 0 ? (
                    paginatedActivity?.map((obj, index) => (
                    <>
                        <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                            <td>{moment(obj?.createdAt).format("MMM-DD-YYYY, h:mm A")}</td>
                            <td>{obj?.userId?.firstName + " " + obj?.userId?.lastName}</td>
                            <td>{obj?.details}</td>
                        </tr>
                    </>
                    ))
                ) : (
                    <tr>
                    <td colSpan={10}>
                        <p className="text-center">No Data Found</p>
                    </td>
                    </tr>
                )}
                </tbody>
                </table>
            </div>
            </div>
            <div className='d-flex justify-content-center'>
                <CustomPagination
                  totalPages={Math.ceil(activity?.length / ITEMS_PER_PAGE)}
                  totalRows={activity?.length}
                  rowsPerPage={ITEMS_PER_PAGE}
                  page={currentPage}
                  handlePage={handlePagination}
                />
                </div>
        </div>

    </Fragment>
  );
};

export default PatientActivity;

